import React from 'react';

import s from './freeShippingContent.scss';

/**
 * "Free shipping" content for popup
 * @constructor
 */
export const FreeShippingContent = () => {
    return (
        <div className={s.popup}>
            <h4 className={s.title}>Free Shipping & Returns</h4>
            <p className={s.content}>
                Enjoy Free Shipping and returns on all orders (for orders in the US & Canada). If,
                for any reason, you are not completely satisfied with your order, you may return it
                within the first 14 days. We even provide you with a return shipping label,no
                questions asked!
            </p>
            <a className={s.link} href="/terms-and-conditions#RETURNPOLICY" target="_blank">
                Read our full return policy.
            </a>
        </div>
    );
};
